import { render, staticRenderFns } from "./StudentCertificationTracking.vue?vue&type=template&id=742e0368&scoped=true&"
import script from "./StudentCertificationTracking.vue?vue&type=script&lang=ts&"
export * from "./StudentCertificationTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e0368",
  null
  
)

export default component.exports